import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface DriverDelays1pDeliveryOrdersProps extends BaseTemplateProps {
  minutes: string
  actionUrl: string
  deviceName?: string
}

// Matches the backend fallback "Driver <id>" or "Driver " (nil shopper_id) — not a real device name.
const FALLBACK_DEVICE_NAME_PATTERN = /^Driver(\s+\d+)?$/

export const DriverDelays1pDeliveryOrders: TemplateDefinition<DriverDelays1pDeliveryOrdersProps> = {
  renderParams: (props: DriverDelays1pDeliveryOrdersProps) => ({
    messageKey: 'notificationsDomain.templates.driverDelays1pDeliveryOrders',
    values: {
      minutes: props.minutes,
    },
  }),
  getTitleParams: (props: DriverDelays1pDeliveryOrdersProps) => {
    if (!props?.deviceName || FALLBACK_DEVICE_NAME_PATTERN.test(props.deviceName)) return undefined
    return {
      messageKey: 'notificationsDomain.templates.driverDelays1pDeliveryOrders.title',
      values: { deviceName: props.deviceName },
    }
  },
  getCTALabelParams: () => ({
    messageKey: 'notificationsDomain.templates.driverDelays1pDeliveryOrders.ctaLabel',
  }),
  getLink: (props: DriverDelays1pDeliveryOrdersProps): string => props?.actionUrl || '',
}
